import { UntypedFormControl } from '@angular/forms';

/*
* Validator for vin field
* */
export function VinLimitValidator(control: UntypedFormControl) {
  const value = control.value;

  return (value && value.length !== 17) ? { error: true, errorMessage: 'errors.vin17' } : null;
}

export function VinInvalidCharValidator(control: UntypedFormControl) {
  const value = control.value;
  const letterNumber = /^[0-9a-zA-Z]+$/;

  return (value && !value.match(letterNumber)) ? { required: true, errorMessage: 'errors.vinAlpha' } : null;
}

export function engineCCValidator(control: UntypedFormControl) {
  const value = control.value;
  const letterNumber = /^[0-9]+$/;

  return (value && !value.match(letterNumber)) ? { required: true, errorMessage: 'errors.engineCC' } : null;
}


export function characterValidator(control: UntypedFormControl) {
  const value = control.value;
  const letterNumber = /^[a-zA-Z]+$/;

  return (value && !value.match(letterNumber)) ? { required: true, errorMessage: 'errors.model' } : null;
}

export function TinLimitValidator(control: UntypedFormControl) {
  const value = control.value;

  return (value == '') ? null : (value && value.length > 3 && value.length < 7) ? null : {
    error: true,
    errorMessage: 'errors.tin6'
  };
}

export function TinInvalidCharValidator(control: UntypedFormControl) {
  const value = control.value;
  const letterNumber = /^[0-9a-zA-Z]+$/;

  return (value && !value.match(letterNumber)) ? { required: true, errorMessage: 'errors.tinAlpha' } : null;
}

export function PidLimitValidator(control: UntypedFormControl) {
  const value = control.value;

  return (value && value.length !== 17) ? { error: true, errorMessage: 'errors.pid17' } : null;
}

export function engineCCLimitValidator(control: UntypedFormControl) {
  const value = control.value;

  return (value && value.length > 4) ? { required: true, errorMessage: 'errors.engineCCLimit' } : null;
}

export function PidInvalidCharValidator(control: UntypedFormControl) {
  const value = control.value;
  const letterNumber = /^[0-9a-zA-Z]+$/;

  return (value && !value.match(letterNumber)) ? { required: true, errorMessage: 'errors.pidAlpha' } : null;
}

export function HinLimitValidator(control: UntypedFormControl) {
  const value = control.value;

  return (value && value.length !== 12) ? { error: true, errorMessage: 'errors.hin12' } : null;
}

export function HinInvalidCharValidator(control: UntypedFormControl) {
  const value = control.value;
  const letterNumber = /^[0-9a-zA-Z]+$/;

  return (value && !value.match(letterNumber)) ? { required: true, errorMessage: 'errors.hinAlpha' } : null;
}

export function aprLimitValidator(control: UntypedFormControl) {
  const value = control.value;

  return (!value) ? { error: true, errorMessage: 'errors.aprLimit' } : null;
}

export function unitIdValidator(control: UntypedFormControl) {
  const value = control.value;
  if (value == '') {
    return null;
  }

  return (value && value.length > 3 && value.length < 18) ? null : { error: true, errorMessage: 'errors.vin17' };
}

export function unitIdCharValidator(control: UntypedFormControl) {
  const value = control.value;
  const letterNumber = /^[0-9a-zA-Z]+$/;

  return (value && !value.match(letterNumber)) ? { required: true, errorMessage: 'errors.vinAlpha' } : null;
}

export function charactersValidator(control: UntypedFormControl) {
  const value = control.value;
  const letterNumber = /^[a-zA-Z]+$/;

  return (value && value.value !== '' && !value.match(letterNumber)) ? {
    required: true,
    errorMessage: 'errors.characters'
  } : null;
}

export function hullValidator(control: UntypedFormControl) {
  const value = control.value;
  const letterNumber = /^[0-9]+$/;
  if (!value) {
    return { required: true, errorMessage: 'errors.required' }
  }
  if (value < 0) {
    return { required: true, errorMessage: 'errors.positiveValue' };
  }
  if (value > 65) {
    return { required: true, errorMessage: 'errors.hull' };
  }
  if (!value.match(letterNumber)) {
    return { required: true, errorMessage: 'errors.numbersOnly' }
  }

  return null;
}
